import { render, staticRenderFns } from "./autoRenewalList.vue?vue&type=template&id=52501eba&scoped=true&"
import script from "./autoRenewalList.vue?vue&type=script&lang=js&"
export * from "./autoRenewalList.vue?vue&type=script&lang=js&"
import style0 from "./autoRenewalList.vue?vue&type=style&index=0&id=52501eba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52501eba",
  null
  
)

export default component.exports